import React, { useMemo } from 'react'
import MatrixBaseAvatar from 'matrix-react-sdk/lib/components/views/avatars/BaseAvatar'
import { isBotOrBridgeUser } from 'ducks/chat/utils/users'

import CustomAvatar from './CustomAvatar'

const BaseAvatar = props => {
  const {
    idName,
    presence = 'offline',
    dispatch,
    member,
    mxEvent,
    avatarUrl,
    userId,
    viewUserOnClick,
    ...rest
  } = props

  const isBorB = useMemo(() => isBotOrBridgeUser(idName), [idName])
  return (
    <>
      {isBorB && <CustomAvatar idName={idName} {...rest} />}
      {!isBorB && (
        <MatrixBaseAvatar
          {...rest} // eslint-disable-line react/jsx-props-no-spreading
          idName={idName}
          className={presence}
          onClick={null}
        />
      )}
    </>
  )
}

export default BaseAvatar
